import React from 'react';
import { SlideInLeft, SlideInRight, FadeInUp } from './Animations';

const items = [
  { icon: '🌿', title: 'Wellness Coaching', desc: 'Build health and income with herbal and wellness products.' },
  { icon: '🏠', title: 'Real Estate', desc: 'Learn how to invest in property and build long term wealth.' },
  { icon: '📱', title: 'Digital Marketing', desc: 'Build your brand online and attract customers on autopilot.' },
  { icon: '🤝', title: 'MLM Coaching', desc: 'Build and lead a team that earns consistently every month.' },
];

export default function Coaching() {
  return (
    <section style={{
      background: '#fff',
      padding: 'clamp(60px, 8vw, 100px) clamp(20px, 4vw, 52px)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: '-80px', right: '-80px',
        width: '400px', height: '400px', borderRadius: '50%',
        background: '#F8FAFB',
      }} />
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-60px',
        width: '300px', height: '300px', borderRadius: '50%',
        background: 'rgba(201,151,58,0.04)',
      }} />

      <div style={{
        maxWidth: '1160px', margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '64px', alignItems: 'center',
        position: 'relative', zIndex: 1,
      }}>
        <SlideInLeft>
          <div>
            <span style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 600, letterSpacing: '4px',
              textTransform: 'uppercase', color: '#C9973A',
              marginBottom: '12px', display: 'block',
            }}>Work With Me</span>
            <div style={{
              width: '48px', height: '3px',
              background: 'linear-gradient(90deg, #1E8449, #27AE60)',
              marginBottom: '20px', borderRadius: '999px',
            }} />
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(28px, 4vw, 46px)', fontWeight: 700,
              lineHeight: 1.15, marginBottom: '20px', color: '#111827',
            }}>
              Ready to Build Your<br />
              <em style={{ fontStyle: 'italic', color: '#C9973A' }}>Multiple Streams?</em>
            </h2>
            <p style={{
              fontSize: '15px', lineHeight: 1.85,
              color: '#6B7280', marginBottom: '16px',
            }}>
              I have spent years building income across wellness, real estate, digital marketing, and network marketing. Now I help others do the same — faster, smarter, and with the right support system.
            </p>
            <p style={{
              fontSize: '15px', lineHeight: 1.85,
              color: '#6B7280', marginBottom: '36px',
            }}>
              Whether you are just starting out or ready to scale, I will show you exactly how to build streams of income that work even when you are not working.
            </p>
            <a href="https://wa.me/2347069495976" target="_blank" rel="noreferrer" style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '12px', fontWeight: 600, letterSpacing: '2px',
              textTransform: 'uppercase', textDecoration: 'none',
              padding: '16px 36px', borderRadius: '999px',
              background: 'linear-gradient(135deg, #1E8449, #27AE60)',
              color: '#fff', display: 'inline-block',
              boxShadow: '0 8px 24px rgba(30,132,73,0.35)',
              transition: 'transform 0.25s, box-shadow 0.25s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.2)';
            }}
            >
              Start The Conversation
            </a>
          </div>
        </SlideInLeft>

        <SlideInRight>
          <div style={{
            display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px',
          }}>
            {items.map((item, i) => (
              <FadeInUp key={item.title} delay={i * 0.1}>
                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid #F0F0F0',
                  borderRadius: '16px', padding: '22px 18px',
                  transition: 'background 0.3s, transform 0.3s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.09)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                >
                  <div style={{ fontSize: '26px', marginBottom: '10px' }}>{item.icon}</div>
                  <h4 style={{
                    fontFamily: "'Playfair Display', serif",
                    fontSize: '15px', fontWeight: 700,
                    color: '#111827', marginBottom: '6px',
                  }}>{item.title}</h4>
                  <p style={{
                    fontSize: '12.5px', lineHeight: 1.6,
                    color: '#6B7280',
                  }}>{item.desc}</p>
                </div>
              </FadeInUp>
            ))}
          </div>
        </SlideInRight>
      </div>
    </section>
  );
}
